module.exports = __webpack_public_path__ + "media/trash.b6b00731.svg";